import { render, staticRenderFns } from "./ManualRightSideBar.vue?vue&type=template&id=a569f05a&scoped=true"
import script from "./ManualRightSideBar.vue?vue&type=script&lang=js"
export * from "./ManualRightSideBar.vue?vue&type=script&lang=js"
import style0 from "./ManualRightSideBar.vue?vue&type=style&index=0&id=a569f05a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a569f05a",
  null
  
)

export default component.exports